import { render, staticRenderFns } from "./subs-main.vue?vue&type=template&id=cc77652e&"
import script from "./subs-main.vue?vue&type=script&lang=js&"
export * from "./subs-main.vue?vue&type=script&lang=js&"
import style0 from "./subs-main.vue?vue&type=style&index=0&id=cc77652e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports